export default __webpack_public_path__ + "static/media/a10.a506ac75.jpg";